<template>
    <!-- 资源组下的任务列表 -->
    <div style='padding-top:1px'>
        <rcTable ref="rcTable"
                 class="clusDetailsTab2"
                 :tableAttr="tableAttr">
            <logModal slot="tootipL"
                      ref="logModal" />
        </rcTable>
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import logModal from './logModal'
import API from '@/service/api'
export default {
    name: 'clusDetailsTab2',
    components: {
        rcTable,
        logModal
    },
    props: ['quote', 'isNoPer', 'isLocak'],
    data () {
        return {
            tableAttr: {
                source: {
                    type: 'get',
                    url: '',
                    params: null
                },
                columns: [
                    {
                        title: this.$i18n.t('名称'),
                        key: 'name',
                        sortable: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.name }, class: 'rc-ellipsis' }, params.row.name)
                        }
                    }, {
                        title: this.$i18n.t('开始时间'),
                        key: 'createdDt',
                        sortable: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.createdDt }, class: 'rc-ellipsis' }, params.row.createdDt)
                        }
                    }, {
                        title: this.$i18n.t('结束时间'),
                        key: 'endDate',
                        sortable: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.endDate }, class: 'rc-ellipsis' }, params.row.endDate)
                        }
                    }, {
                        title: this.$i18n.t('状态'),
                        key: 'status',
                        sortable: true,
                        render: (h, params) => {
                            const color = {
                                failure: 'red',
                                pending: 'yellow',
                                success: 'green'
                            }[params.row.status]
                            const yuanClass = {
                                'yuan-div': true
                            }
                            yuanClass[`rc-bacg-${color}`] = true
                            const arr = [
                                h('span', {
                                    class: yuanClass
                                }),
                                h('span', { attrs: { title: params.row.statusName }, class: `rc-color-${color}` }, this.$i18n.t(params.row.statusName))
                            ]
                            return h('p', { class: 'rc-ellipsis' }, arr)
                        }
                    }, {
                        title: this.$i18n.t('进度'),
                        key: 'progressRate',
                        render: (h, params) => {
                            let num = parseFloat((params.row.progressRate * 100).toFixed(2))
                            if (params.row.status === 'failure' && num >= 100) {
                                num = 99.99
                            }
                            return h('i-progress', {
                                props: { percent: num, status: params.row.status === 'failure' ? 'wrong' : params.row.status === 'success' ? 'success' : 'normal' }
                            })
                        }
                    }
                ]
            }
        }
    },
    created () {
        if (this.quote === 'source') {
            this.tableAttr.source.url = this.urlFormat(API.GET_RESGROUP_TASKS, true, [this.$route.params.id])
        } else if (this.quote === 'host') {
            this.tableAttr.source.url = this.urlFormat(API.TASKS, true)
            this.tableAttr.source.params = {
                target: this.$route.params.id
            }
            const vm = this
            // 订阅更新列表
            this.taskSubscribe = this.$websocket('/topic/task/' + this.$route.params.id, (result) => {
                vm.$refs.rcTable.refreshTable({
                    target: this.$route.params.id
                })
            })
        }
    },
    methods: {
        refreshTable () {
            this.$refs.rcTable.refreshTable()
        },
        deleteById (id) {
            this.$rcModal({
                message: this.$i18n.t('您确定要删除该日志吗'),
                callback: () => {
                    this.axios.delete(this.urlFormat(API.GET_RES_SCRIPT_LOGS, false, [id])).then(res => {
                        this.refreshTable()
                    })
                }
            })
        },
        log (id) {
            const url = this.urlFormat(API.GET_RES_SCRIPT_LOGS, false, [id])
            this.$refs.logModal.openModal(url)
        }
    },
    beforeDestroy () {
        // 取消websocket订阅
        if (this.taskSubscribe) {
            this.taskSubscribe.unsubscribe()
        }
    }
}
</script>

<style lang="less">
.clusDetailsTab2 {
    .ivu-progress-outer {
        width: calc(~"100% - 55px");
    }
    .yuan-div {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #ccc;
        margin-right: 5px;
        display: inline-block;
    }
    .rc-color-red {
        color: #ef4235;
    }
    .rc-color-blue {
        color: #3498dc;
    }
    .rc-color-yellow {
        color: #ffc000;
    }
    .rc-bacg-red {
        background-color: #ef4235;
    }
    .rc-bacg-blue {
        background-color: #3498dc;
    }
    .rc-bacg-green {
        background-color: #1ebd62;
    }
    .rc-bacg-yellow {
        background-color: #ffc000;
    }
}
</style>
